import type { AdsHistoryGroupedEntry } from '../components/AdsHistoryGroupedView.mockData';

export interface AdsHistoryGroupedFilterValues {
  user: string;
  dateFrom: string;
  dateTo: string;
  flow: string;
  hypothesis: string;
  customer: string;
  technology: string;
  status: string;
}

export const EMPTY_FILTERS: AdsHistoryGroupedFilterValues = {
  user: '',
  dateFrom: '',
  dateTo: '',
  flow: '',
  hypothesis: '',
  customer: '',
  technology: '',
  status: '',
};

// Mock — replace with real /api/v1/users?has_facebook_access=true response.
export const MOCK_FACEBOOK_USERS: string[] = [
  'eleonora.hafurova@welltech.com',
  'yevhenii.dvirnyk@welltech.com',
  'oleksandr.kovalenko@welltech.com',
  'maryna.petrenko@welltech.com',
  'dmytro.sydorenko@welltech.com',
  'anastasiia.bondarenko@welltech.com',
  'ivan.kravchenko@welltech.com',
];

export function applyGroupedFilters(
  entries: AdsHistoryGroupedEntry[],
  f: AdsHistoryGroupedFilterValues,
): AdsHistoryGroupedEntry[] {
  return entries.filter((e) => {
    if (f.user && !e.email.toLowerCase().includes(f.user.toLowerCase())) return false;
    if (f.dateFrom && e.created_at < f.dateFrom) return false;
    if (f.dateTo && e.created_at > `${f.dateTo}T23:59:59Z`) return false;
    if (f.flow && e.flow !== f.flow) return false;
    if (f.hypothesis && e.hypothesis !== f.hypothesis) return false;
    if (f.customer && e.customer !== f.customer) return false;
    if (f.technology && e.technology !== f.technology) return false;
    if (f.status === 'success' && !e.status) return false;
    if (f.status === 'failed' && e.status) return false;
    return true;
  });
}
